import { render, staticRenderFns } from "./ImpresionDocumentar.vue?vue&type=template&id=1a9ee94e&scoped=true&"
import script from "./ImpresionDocumentar.vue?vue&type=script&lang=js&"
export * from "./ImpresionDocumentar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ee94e",
  null
  
)

export default component.exports